const study = [
    {
        path: '/study',
        name: 'study',
        redirect: '/trainInfo',
        meta: { breadcrumb: '学习中心', requiresAuth: true },
        component: () => import('@/views/study/StudyMain.vue'),
        children: [
            // 个人资料
            {
                path: '/userInfo/:index?',
                name: 'userInfo',
                meta: { breadcrumb: '个人资料', requiresAuth: true },
                component: () => import('@/views/study/pages/UserInfo.vue')
            }, 
            // 培训岗位
            {
                path: '/trainInfo',
                name: 'trainInfo',
                meta: { breadcrumb: '培训岗位', requiresAuth: true },
                redirect: '/classRoom',
                component: () => import('@/views/study/pages/TrainInfo.vue'),
                children: [
                    {
                        path: '/classRoom',
                        name: 'classRoom',
                        meta: { breadcrumb: '在学岗位', requiresAuth: true },
                        component: () => import('@/views/study/trainModules/ClassRoom.vue')
                    }, {
                        path: '/classDetail',
                        name: 'classDetail',
                        meta: { breadcrumb: '岗位详情', requiresAuth: true },
                        component: () => import('@/views/study/trainModules/ClassDetail.vue')
                    }, {
                        path: '/completeClass',
                        name: 'completeClass',
                        meta: { breadcrumb: '完成岗位', requiresAuth: true },
                        component: () => import('@/views/study/trainModules/CompleteClass.vue')
                    }, {
                        path: '/myExam',
                        name: 'myExam',
                        meta: { breadcrumb: '我的考试', requiresAuth: true },
                        component: () => import('@/views/study/trainModules/MyExam.vue')
                    }, {
                        path: '/myExamCourse',
                        name: 'myExamCourse',
                        meta: { breadcrumb: '我的考试', requiresAuth: true },
                        component: () => import('@/views/study/trainModules/MyExamCourse.vue')
                    }, {
                        path: '/learnHour',
                        name: 'learnHour',
                        meta: { breadcrumb: '学时统计', requiresAuth: true },
                        component: () => import('@/views/study/trainModules/LearnHour.vue')
                    }
                ]
            },
            // 报名订单
            {
                path: '/orderInfo',
                name: 'orderInfo',
                meta: { breadcrumb: '报名订单', requiresAuth: true },
                redirect: '/mpOrderModule',
                component: () => import('@/views/study/pages/OrderInfo.vue'),
                children: [
                    {
                        path: '/allOrder',
                        name: 'allOrder',
                        meta: { breadcrumb: '全部订单', requiresAuth: true },
                        component: () => import('@/views/study/orderModules/AllOrderModule.vue')
                    }, {
                        path: '/awaitPay',
                        name: 'awaitPay',
                        meta: { breadcrumb: '待付款订单', requiresAuth: true },
                        component: () => import('@/views/study/orderModules/AwaitPayModule.vue')
                    }, {
                        path: '/hasPayModule',
                        name: 'hasPayModule',
                        meta: { breadcrumb: '已付款订单', requiresAuth: true },
                        component: () => import('@/views/study/orderModules/HasPayModule.vue')
                    }, {
                        path: '/hasExpiredModule',
                        name: 'hasExpiredModule',
                        meta: { breadcrumb: '已失效订单', requiresAuth: true },
                        component: () => import('@/views/study/orderModules/HasExpiredModule.vue')
                    }, 
                    // 根据小程序接口开发页面
                    {
                        path: '/mpOrderModule',
                        name: 'mpOrderModule',
                        meta: { breadcrumb: '全部订单', requiresAuth: true },
                        component: () => import('@/views/study/orderModules/MpApiOrderModule.vue')
                    }, {
                        path: '/mpAwaitPayModule',
                        name: 'mpAwaitPayModule',
                        meta: { breadcrumb: '全部订单', requiresAuth: true },
                        component: () => import('@/views/study/orderModules/MpAwaitPayModule.vue')
                    }, {
                        path: '/mpHasPayModule',
                        name: 'mpHasPayModule',
                        meta: { breadcrumb: '全部订单', requiresAuth: true },
                        component: () => import('@/views/study/orderModules/MpApiHasPayModule.vue')
                    }, {
                        path: '/mpRefundModule',
                        name: 'mpRefundModule',
                        meta: { breadcrumb: '申请退款', requiresAuth: true },
                        component: () => import('@/views/study/orderModules/MpRefundModule.vue')
                    }, {
                        path: '/mpInvoiceModule',
                        name: 'mpInvoiceModule',
                        meta: { breadcrumb: '我的发票', requiresAuth: true },
                        component: () => import('@/views/study/orderModules/MpInvoiceModule.vue')
                    }
                ]
            },
            // 培训证书
            {
                path: '/certificateInfo',
                name: 'certificateInfo',
                meta: { breadcrumb: '培训证书', requiresAuth: true },
                component: () => import('@/views/study/pages/CertificateInfo.vue')
            },
            // 学时证明
            {
                path: '/xszm',
                name: 'xszm',
                meta: { breadcrumb: '培训证书', requiresAuth: true },
                component: () => import('@/views/study/pages/xszm.vue')
            },
            // 我的考试
            {
                path: '/examTip',
                name: 'examTip',
                meta: { breadcrumb: '考前提示', requiresAuth: true },
                component: () => import('@/views/study/examModules/ExamTip.vue')
            }, {
                path: '/examInfo',
                name: 'examInfo',
                meta: { breadcrumb: '我的考试', requiresAuth: true },
                component: () => import('@/views/study/examModules/ExamInfo.vue')
            }, {
                path: '/examPreview',
                name: 'examPreview',
                meta: { breadcrumb: '答卷预览', requiresAuth: true },
                component: () => import('@/views/study/examModules/ExamPreview.vue')
            }
        ]
    },
]

export default study